import { useAuth } from '_/contexts/AuthContext';
import { ReactNode, ReactElement } from 'react';

interface PermitSuperAdminProps {
  children: ReactNode;
}

function PermitSuperAdmin({ children }: PermitSuperAdminProps): ReactElement | null {
  const { isSuperAdmin } = useAuth();

  return isSuperAdmin ? (children as ReactElement) : null;
}

export default PermitSuperAdmin;
